import { useEffect, useState } from 'react';
import Input from 'components/Basic/Input';
import { convertFeetToMetric, convertMetricToFeet } from '../../util';
import { DivInputWithUnit, DivRowHeight, DivFieldError } from './style';

const MAX_STARTING_HEIGHT_FT = convertMetricToFeet(100);

type Props = {
	value?: number;
	onChange: (value: number) => void;
	disabled?: boolean;
	singleField?: boolean;
};

const toFeetDisplay = (m?: number) => `${m !== undefined ? convertMetricToFeet(m) : ''}`;

export default function StartingHeight({ value, onChange, disabled, singleField }: Props) {
	const [localValue, setLocalValue] = useState(toFeetDisplay(value));
	const [error, setError] = useState(false);

	useEffect(() => {
		setLocalValue(toFeetDisplay(value));
	}, [value]);

	function handleChange(evt: React.ChangeEvent<HTMLInputElement>) {
		const raw = evt.target.value;
		setLocalValue(raw);

		if (!raw) {
			setError(false);
			onChange(NaN);
			return;
		}

		const ft = +raw;
		const isOverLimit = ft > MAX_STARTING_HEIGHT_FT;
		setError(isOverLimit);
		onChange(isOverLimit ? NaN : convertFeetToMetric(ft, 'm', 6));
	}

	function handleBlur() {
		const ft = +localValue;
		if (!localValue.trim() || !Number.isFinite(ft)) {
			setLocalValue(toFeetDisplay(value));
			setError(false);
			return;
		}
		if (ft > MAX_STARTING_HEIGHT_FT) {
			setLocalValue(`${MAX_STARTING_HEIGHT_FT}`);
			onChange(convertFeetToMetric(MAX_STARTING_HEIGHT_FT, 'm', 6));
			setError(false);
		}
	}

	return (
		<DivRowHeight className={`facet-slider-slope-info${singleField ? ' single-field-wrap' : ''}${error ? ' error' : ''}`}>
			<label>Starting Height:</label>
			<DivInputWithUnit $stretch={singleField} className={error ? 'error' : ''}>
				<Input
					type="number"
					step="any"
					min={0}
					value={localValue}
					onChange={handleChange}
					onBlur={handleBlur}
					onKeyUp={(e) => e.stopPropagation()}
					disabled={disabled}
				/>
				<span className='unit'>ft</span>
			</DivInputWithUnit>
			{error && <DivFieldError>{`Must be <= ${MAX_STARTING_HEIGHT_FT}`}</DivFieldError>}
		</DivRowHeight>
	);
}
